module.exports = __webpack_public_path__ + "static/media/TopDelivery_1.c0a12ac0.png";